import $ from "cash-dom";

export default (function () {
    var selector = ".cover";

    function init() {
        if (!$(selector).length) return;

        jdmn.log("function_cover.js initialized", "green");

        $(selector).each(function () {
            var instance = $(this).is("lottie-player") ? $($(this)[0].shadowRoot).find("#animation") : $(this);
            var parent = $(this).parent();
            var instanceRatio = instance.width() / instance.height();
            var parentRatio = parent.width() / parent.height();

            instanceRatio = Math.ceil(instanceRatio * 100) / 100;
            parentRatio = Math.ceil(parentRatio * 100) / 100;

            if (instanceRatio < parentRatio) {
                $(this).css({ width: "100%", height: "auto" });
            }

            if (instanceRatio > parentRatio) {
                $(this).css({ width: "auto", height: "100%" });
            }
        });
    }

    $(document).ready(init);
    $(window).on("resizeEnd fetchSuccess", init);
})();
